import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { authCheckQueryWithCustomError } from '@/shared/state/api';

export const generatedApi = createApi({
	reducerPath: 'generatedApi',
	baseQuery: authCheckQueryWithCustomError,
	endpoints: () => ({}),
});
